import { render, staticRenderFns } from "./FleetGroupTable.vue?vue&type=template&id=c96b56fe&"
import script from "./FleetGroupTable.vue?vue&type=script&lang=js&"
export * from "./FleetGroupTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports